class RoRegisterForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.submitButton = this.form.querySelector('[type=submit]');
    this.passwordInputs = this.form.querySelectorAll('[type=password]');
    
    this.confirmPasswordInput = this.passwordInputs[1];
    this.confirmPasswordField = this.confirmPasswordInput.closest('.tw-form-field');
    this.confirmPasswordLabel = this.confirmPasswordField.querySelector('label');
    this.confirmPasswordLabelDefaultText = this.confirmPasswordLabel.innerText;

    this.passwordStrength = 0;
  }

  connectedCallback() {
    subscribe(PUB_SUB_EVENTS.passwordStrengthChecked, (passwordStrengthCheck) => {
      this.passwordStrength = passwordStrengthCheck.strength;
      this.updateSubmitButtonState();
    });

    this.passwordInputs.forEach(passwordInput => {
      passwordInput.addEventListener('input', this.checkPasswordsMatch.bind(this));
    });
  }

  checkPasswordsMatch() {
    if (this.passwordInputs[0].value === '' || this.passwordInputs[1].value === '' || this.passwordInputs[0].value === this.passwordInputs[1].value) {
      this.confirmPasswordLabel.innerText = this.confirmPasswordLabelDefaultText;
      this.confirmPasswordInput.classList.remove('js-invalid');
      this.passwordsMatch = true;
    } else {
      this.confirmPasswordLabel.innerText = this.dataset.confirmPasswordError ?? '';
      this.confirmPasswordInput.classList.add('js-invalid');
      this.passwordsMatch = false;
    }

    this.updateSubmitButtonState();
  }

  updateSubmitButtonState() {
    if (this.passwordStrength == 5 && this.passwordsMatch) {
      this.submitButton.removeAttribute('disabled');
    } else {
      this.submitButton.setAttribute('disabled', true);
    }
  }
}

customElements.define('ro-register-form', RoRegisterForm);


class RoPasswordStrengthChecker extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.passwordInput = this.form.querySelector('[type=password]');

    this.indicators = this.querySelectorAll('li');
    this.helpText = this.querySelector('p');

    this.strengthTests = [
      {
        regex: /[0-9]/,
        "helpText": this.dataset.helpNumber ?? '',
      },
      {
        regex: /[a-z]/,
        "helpText": this.dataset.helpLcase ?? '',
      },
      {
        regex: /[A-Z]/,
        "helpText": this.dataset.helpUcase ?? '',
      },
      {
        regex: /[^0-9a-zA-Z]/,
        "helpText": this.dataset.helpSpecial ?? '',
      }
    ];
  }

  connectedCallback() {
    this.passwordInput.addEventListener('keyup', this.strengthChecker.bind(this));
  }

  strengthChecker() {
    let strength = 0;
    let helpTextSet = false;

    if (this.passwordInput.value.length >= 8) {
      strength++;
    } else {
      this.helpText.innerText = this.dataset.helpLength ?? '';
      helpTextSet = true;
    }

    this.strengthTests.forEach((item) => {
      if (item.regex.test(this.passwordInput.value)) {
        strength++;
      } else {
        if (! helpTextSet) {
          this.helpText.innerText = item.helpText;
          helpTextSet = true;
        }
      }
    });

    this.updateIndicators(strength);

    if (! helpTextSet) {
      this.helpText.innerText = '';
    }

    publish(PUB_SUB_EVENTS.passwordStrengthChecked, { strength: strength });
  }

  updateIndicators(strength) {
    this.indicators.forEach((indicator, index) => {
      if (index <= strength - 1) {
        indicator.classList.add('[&]:tw-bg-black');
      } else {
        indicator.classList.remove('[&]:tw-bg-black');
      }
    });
  }
}

customElements.define('ro-password-strength-checker', RoPasswordStrengthChecker);